<template>
	<div v-if="loading" style="width: 100%; height: 100%">
		<nta-loading
			:title="symbolsStore.GUILabel('94766a0b-d93d-491c-a298-2d72392fc682')"
			:text="symbolsStore.GUILabel('349fdb7f-69c6-4e57-9885-2cc102e7f243')"
			:symbol-lang="domainStore.languagePreference"
			style="height: 50%; width: 50%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
		/>
	</div>
</template>

<script setup lang="ts">
import router from "../../../router";
import { ref, onMounted } from "vue";
import { useInstanceWorkspacesStore } from "../../../store/i-workspace";
import { useInstanceDataspacesStore } from "../../../store/i-dataspace";
import { useBetaStore } from "../../../store/beta";
import { useDomainStore } from "../../../store/domain";
import { useSymbolsStore } from "../../../store/symbols";

let domainId = router.currentRoute.value.params.domainId as string;
let templateWorkspaceId = router.currentRoute.value.params.templateWorkspaceId as string;
let betaCaseId = router.currentRoute.value.params.betaCaseId as string;
let presetId = router.currentRoute.value.params.presetId as string;

let title = router.currentRoute.value.query.title as string;
let description = router.currentRoute.value.query.description as string;
let email = router.currentRoute.value.query.email as string;

const workspacesStore = useInstanceWorkspacesStore();
const dataspacesStore = useInstanceDataspacesStore();
const betaStore = useBetaStore();
const domainStore = useDomainStore();
const symbolsStore = useSymbolsStore();

const loading = ref(false);

function setOperatorWorkspaceId(betaCaseId: string, operatorWorkspaceId: string) {
	const protocol = window.location.protocol === "http:" ? "http" : "https";
	const isProduction = protocol === "https";
	const route = `/api/v1.0/setOperatorWorkspaceId`;
	let url: string = "";
	if (isProduction) {
		url = "https://kinas.notitia.world" + route;
	} else {
		url = "http://localhost:3002" + route;
	}
	fetch(url, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Bearer ${domainStore.authToken}`,
		},
		body: JSON.stringify({ betaCaseId, operatorWorkspaceId }),
	}).catch((err) => {
		console.log(err);
	});
}

onMounted(async () => {
	if (!domainId) return;
	if (typeof domainId !== "string") return;
	if (!templateWorkspaceId) return;
	if (typeof templateWorkspaceId !== "string") return;
	if (!betaCaseId) return;
	if (typeof betaCaseId !== "string") return;

	loading.value = true;
	let domain = await domainStore.loadDomain(domainId);
	await dataspacesStore.addPermittedUserId(domainId, betaStore.kinasBetaDataspaceId, domainStore.account.id);
	let newData = await workspacesStore.addWorkspace(
		betaStore.kinasBetaDataspaceId,
		templateWorkspaceId,
		title || "title",
		(description || "description") + " - " + (email || "no email")
	);
	if (!newData.id) return;

	let descriptorNode: any = Object.values(newData.graph.nodes).find(
		(n: any) => n.type === "workspace" && n.layer === "instance" && n.label && n.description
	);
	if (descriptorNode) {
		workspacesStore.setWorkspaceDescriptor(
			domainId,
			betaStore.kinasBetaDataspaceId,
			newData.id,
			descriptorNode.label,
			descriptorNode.description
		);
	}

	setOperatorWorkspaceId(betaCaseId, newData.id);
	const dataspace = dataspacesStore.getById(betaStore.kinasBetaDataspaceId);
	if (!dataspace) return;
	dataspace.workspaces.push(newData.id);
	await dataspacesStore.updateDataspace(dataspace);
	loading.value = false;
	router.replace("/beta/instance/" + domainId + "/" + newData.id + "/" + betaCaseId + "/" + presetId);
});
</script>
